
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/video/playlists",
      function () {
        return require("private-next-pages/video/playlists/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/video/playlists"])
      });
    }
  